import React from 'react';



function HandleError(props) {
    return (
        <div>
            Something went wrong! Please Try again Later.....
        </div>
    );
}

export default HandleError;